import { Component, OnInit } from '@angular/core'
import { MatBottomSheetRef } from '@angular/material/bottom-sheet'
import { CallerService } from '../services/caller.service'
import { ChatMessage } from '../ngrx-store/app.state'
import { MessageSegment, ParseMentionsPipe } from '../parse-mentions.pipe'

@Component({
    selector: 'app-bookmarked-messages-bottomsheet',
    templateUrl: './bookmarked-messages-bottomsheet.component.html',
    styleUrls: ['./bookmarked-messages-bottomsheet.component.css'],
})
export class BookmarkedMessagesBottomsheetComponent implements OnInit {
    bookmarkedMessages: ChatMessage[] = []
    isLoading = true

    // Stateless pure transform with no injected deps of its own — safe to instantiate directly
    // rather than adding it to a provider list just for this one non-template usage.
    private parseMentionsPipe = new ParseMentionsPipe()

    constructor(
        private bottomSheetRef: MatBottomSheetRef<BookmarkedMessagesBottomsheetComponent>,
        private callerService: CallerService,
    ) {}

    ngOnInit(): void {
        this.callerService.getBookmarkedChatMessages().subscribe({
            next: (res: any) => {
                this.bookmarkedMessages = res.body?.data ?? []
                this.isLoading = false
            },
            error: () => {
                this.isLoading = false
            },
        })
    }

    snippet(message: string): string {
        return this.parseMentionsPipe
            .transform(message)
            .map((segment: MessageSegment) => (segment.type === 'mention' ? '@' + segment.value : segment.value))
            .join('')
    }

    removeBookmark(chat: ChatMessage, event: Event): void {
        event.stopPropagation()
        if (typeof chat.id !== 'number') return

        this.callerService.unbookmarkChatMessage(chat.id).subscribe()
        this.bookmarkedMessages = this.bookmarkedMessages.filter((m) => m.id !== chat.id)
    }

    goToChat(chat: ChatMessage): void {
        this.bottomSheetRef.dismiss(chat.room)
    }

    close(): void {
        this.bottomSheetRef.dismiss()
    }
}
